import {AbstractControl} from "@angular/forms";
import {Expose} from "class-transformer";

//todo to be announced
export class LeadModel {
  @Expose({ name: 'id' })
  id!: number;
  @Expose({ name: 'unviewed' })
  unviewed!: boolean;
  @Expose({ name: 'name' })
  name!: string;
  @Expose({ name: 'phone' })
  phone!: string;
  @Expose({ name: 'email' })
  email!: string;
  @Expose({ name: 'lead_source' })
  leadSource!: { id: number; name: string; };
  @Expose({ name: 'units' })
  units!: { id: number; identifier: string; }[];
  @Expose({ name: 'score' })
  score!: number;
  @Expose({ name: 'last_activity' })
  lastActivity!: number;
  @Expose({ name: 'status' })
  status!: ELeadStatus;

  selected = false;

  get cleanedPhone(): string {
    if (!this.phone) {
      return '';
    }
    return this.phone.replace(/\D/g, '');
  }
}

export enum ELeadStatus {
  NoOffer = "no_offer",
  DialogStarted = "dialog_started",
  Registered = "registered",
  ContactAttempted = "contact_attempted",
  AwaitingDecision = "awaiting_decision",
  ShowingBooked = "showing_booked",
  OfferSubmitted = "offer_submitted",
}

//todo to be announced
type LeadFormGroupControlKeys = | 'name' | 'phone' | 'email' | 'postalCode' | 'leadSource' | 'score' | 'status' | 'unit' | 'internalComment';
export type LeadFormGroupType = {
  [key in LeadFormGroupControlKeys]: AbstractControl<any>;
};
export type LeadFormGroupRawValue = {
  [key in LeadFormGroupControlKeys]: any;
};
